/* ==========================================================================
   MODKEI CRO — "En movimiento"
   Los clips no se descargan hasta que entran en pantalla, se pausan al salir
   y se pueden parar a mano. Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__mkVideoInit) return;
  window.__mkVideoInit = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function frameOf(video) {
    return video.closest('.mk-vid__frame');
  }

  function markPaused(video, paused) {
    var frame = frameOf(video);
    if (frame) frame.setAttribute('data-paused', paused ? 'true' : 'false');
    var btn = frame && frame.querySelector('[data-mk-vid-toggle]');
    if (btn) btn.setAttribute('aria-label', paused ? 'Reproducir vídeo' : 'Pausar vídeo');
  }

  function play(video) {
    if (video.dataset.mkUserPaused === 'true') return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      // Autoplay can be refused (data saver, low power mode). Leave the poster
      // and the play button — never let a rejection surface as an error.
      p.then(function () {
        markPaused(video, false);
      }).catch(function () {
        markPaused(video, true);
      });
    } else {
      markPaused(video, false);
    }
  }

  function setup(root) {
    var videos = (root || document).querySelectorAll('[data-mk-vid-el]');
    if (!videos.length) return;

    videos.forEach(function (video) {
      if (video.dataset.mkVidReady === 'true') return;
      video.dataset.mkVidReady = 'true';
      markPaused(video, true);

      var frame = frameOf(video);
      var btn = frame && frame.querySelector('[data-mk-vid-toggle]');

      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) {
            video.dataset.mkUserPaused = 'false';
            play(video);
          } else {
            video.dataset.mkUserPaused = 'true';
            video.pause();
            markPaused(video, true);
          }
        });
      }

      video.addEventListener('pause', function () {
        markPaused(video, true);
      });
      video.addEventListener('playing', function () {
        markPaused(video, false);
      });
    });

    if (reduceMotion) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.preload = 'metadata';
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.45 }
    );

    videos.forEach(function (video) {
      io.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  // Theme editor: sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
